module.exports = __webpack_public_path__ + "static/media/SY.a7803171.png";